var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('v-slider',{attrs:{"max":"1","min":"0","step":".01","append-icon":"mdi-opacity","prepend-icon":"mdi-opacity"},model:{value:(_vm.opacitySlideValue),callback:function ($$v) {_vm.opacitySlideValue=$$v},expression:"opacitySlideValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }